import { render, staticRenderFns } from "./deleted.vue?vue&type=template&id=3b648e90&"
import script from "./deleted.vue?vue&type=script&lang=js&"
export * from "./deleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports